import React from 'react';
const rows = [{
  label: 'Flow',
  icon: '🌊',
  before: 'Flow Anxiety: Sunday night stress searching for sequences that don’t “flow.”',
  after: '−90% Planning Time. Complete classes on your tablet in 2 clicks.'
}, {
  label: 'Safety',
  icon: '🛡️',
  before: 'Safety Doubt: Worrying about students with pain or injuries without a clear protocol.',
  after: 'Total Safety. Therapeutic protocols and safe modifications included.'
}, {
  label: 'Variety',
  icon: '🎨',
  before: 'Repetition: Teaching the same 10 poses because you’re too tired to innovate.',
  after: 'Infinite Variety. 52 weekly themes and elegant transitions for fresh energy.'
}, {
  label: 'Presence',
  icon: '💫',
  before: 'Energy Burnout: Arriving on the mat mentally drained from admin.',
  after: 'Pure Presence. Arrive full of energy, ready to lead with your heart.'
}];
const bottomStats = [{
  num: '+150h',
  label: 'Saved per year',
  icon: '⏱️'
}, {
  num: '2 Clicks',
  label: 'For every finished class',
  icon: '🎯'
}, {
  num: '100%',
  label: 'Professional',
  icon: '✨'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4 relative overflow-hidden" data-id="element-61">
      <div className="absolute top-20 -left-20 w-[400px] h-[400px] bg-primary/8 rounded-full blur-[120px] pointer-events-none" data-id="element-62"></div>
      <div className="absolute bottom-20 -right-20 w-[400px] h-[400px] bg-secondary/8 rounded-full blur-[120px] pointer-events-none" data-id="element-63"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-64">
        <div className="text-center mb-14" data-id="element-65">
          <span className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 text-primary font-bold uppercase tracking-wider text-xs sm:text-sm px-4 py-1.5 rounded-full mb-5" data-id="element-66">
            <span data-id="element-67">⚡</span> The Transformation
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight leading-[1.1]" data-id="element-68">
            From an overworked instructor to an{' '}
            <span className="relative inline-block" data-id="element-69">
              <span className="relative z-10 text-primary" data-id="element-70">inspired guide</span>
              <span className="absolute bottom-1 left-0 w-full h-3 bg-secondary/30 -z-0 rounded-full" data-id="element-71"></span>
            </span>
            .
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-72">
            This is how your week changes with{' '}
            <span className="font-bold text-text-main" data-id="element-73">Yoga Ready</span> in your
            hands.
          </p>
        </div>

        <div className="relative bg-gradient-to-br from-badge-red/12 via-badge-red/8 to-transparent border border-badge-red/25 rounded-3xl p-8 sm:p-10 mb-16 overflow-hidden" data-id="element-74">
          <div className="absolute top-0 right-0 text-[160px] sm:text-[220px] leading-none opacity-[0.06] select-none -translate-y-6 translate-x-4 pointer-events-none" data-id="element-75">
            ⏳
          </div>
          <div className="relative grid grid-cols-1 sm:grid-cols-[auto_1fr] gap-6 sm:gap-10 items-center" data-id="element-76">
            <div className="text-center sm:text-left flex-shrink-0" data-id="element-77">
              <p className="text-badge-red font-black text-5xl sm:text-7xl leading-none tracking-tighter" data-id="element-78">
                150+
              </p>
              <p className="text-badge-red/90 font-bold text-sm sm:text-base uppercase tracking-wider mt-2" data-id="element-79">
                Hours Saved Per Year
              </p>
            </div>
            <div className="h-px sm:h-20 sm:w-px bg-badge-red/20 mx-auto" data-id="element-80"></div>
            <p className="text-text-main text-base sm:text-lg font-medium leading-relaxed" data-id="element-81">
              <span className="text-badge-red font-bold uppercase text-xs sm:text-sm tracking-wider block mb-2" data-id="element-82">
                The True Price of Over-Planning
              </span>
              Manual planning robs you of your own practice. Scrawling stick
              figures on napkins and endless scrolling on Pinterest is costing
              you a{' '}
              <span className="text-badge-red font-black underline decoration-2 underline-offset-2" data-id="element-83">
                full month of work
              </span>{' '}
              every year.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 sm:gap-6 mb-5" data-id="element-84">
          <div className="text-center" data-id="element-85">
            <span className="inline-flex items-center gap-2 text-badge-red font-black uppercase tracking-wider text-[10px] sm:text-sm" data-id="element-86">
              <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red" data-id="element-87"></span>
              <span className="hidden sm:inline" data-id="element-88">Without the Kit</span>
              <span className="sm:hidden" data-id="element-89">Without</span>
            </span>
          </div>
          <div className="text-center" data-id="element-90">
            <span className="inline-flex items-center gap-2 text-primary font-black uppercase tracking-wider text-[10px] sm:text-sm" data-id="element-91">
              <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-primary" data-id="element-92"></span>
              <span className="hidden sm:inline" data-id="element-93">With Yoga Ready</span>
              <span className="sm:hidden" data-id="element-94">With Kit</span>
            </span>
          </div>
        </div>

        <div className="space-y-4 sm:space-y-5 mb-14" data-id="element-95">
          {rows.map((row, i) => <div key={i} className="relative grid grid-cols-2 gap-3 sm:gap-6 items-stretch group" data-id="element-96">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20 hidden sm:flex items-center gap-2 bg-bg-alt border border-border-light rounded-full px-4 py-1 shadow-md" data-id="element-97">
                <span className="text-base" data-id="element-98">{row.icon}</span>
                <span className="text-text-main font-black text-xs uppercase tracking-wider" data-id="element-99">
                  {row.label}
                </span>
              </div>

              <div className="relative bg-bg-alt border border-badge-red/15 rounded-2xl p-5 sm:p-6 overflow-hidden" data-id="element-100">
                <div className="absolute inset-0 bg-gradient-to-br from-badge-red/[0.04] to-transparent pointer-events-none" data-id="element-101"></div>
                <div className="sm:hidden flex items-center gap-1.5 mb-2" data-id="element-102">
                  <span className="text-base" data-id="element-103">{row.icon}</span>
                  <span className="text-badge-red font-black text-[10px] uppercase tracking-wider" data-id="element-104">
                    {row.label}
                  </span>
                </div>
                <div className="relative flex items-start gap-3" data-id="element-105">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-badge-red/15 border border-badge-red/30 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-106">
                    <span className="text-badge-red font-black text-xs sm:text-sm" data-id="element-107">
                      ✕
                    </span>
                  </div>
                  <p className="text-text-sec text-sm sm:text-base font-medium leading-relaxed" data-id="element-108">
                    {row.before}
                  </p>
                </div>
              </div>

              <div className="relative bg-gradient-to-br from-primary/8 via-bg-alt to-bg-alt border border-primary/30 rounded-2xl p-5 sm:p-6 overflow-hidden shadow-[0_8px_24px_-12px_rgba(139,111,191,0.25)]" data-id="element-109">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-110"></div>
                <div className="sm:hidden flex items-center gap-1.5 mb-2" data-id="element-111">
                  <span className="text-base" data-id="element-112">{row.icon}</span>
                  <span className="text-primary font-black text-[10px] uppercase tracking-wider" data-id="element-113">
                    {row.label}
                  </span>
                </div>
                <div className="relative flex items-start gap-3" data-id="element-114">
                  <div className="w-6 h-6 sm:w-7 sm:h-7 rounded-full bg-check-green/15 border border-check-green/40 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-115">
                    <span className="text-check-green font-black text-xs sm:text-sm" data-id="element-116">
                      ✓
                    </span>
                  </div>
                  <p className="text-text-main text-sm sm:text-base font-bold leading-relaxed" data-id="element-117">
                    {row.after}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div data-id="element-118">
          <p className="text-center text-text-sec text-xs sm:text-sm font-medium uppercase tracking-wider mb-5" data-id="element-119">
            ✨ The Net Result
          </p>
          <div className="grid grid-cols-3 gap-3 sm:gap-6" data-id="element-120">
            {bottomStats.map((s, i) => <div key={i} className="relative bg-bg-alt border border-primary/20 rounded-2xl p-4 sm:p-6 text-center overflow-hidden group hover:border-primary/40 transition-colors" data-id="element-121">
                <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent opacity-60" data-id="element-122"></div>
                <div className="text-xl sm:text-3xl mb-2 sm:mb-3 opacity-80" data-id="element-123">
                  {s.icon}
                </div>
                <p className="text-primary font-black text-xl sm:text-3xl mb-1 tracking-tight" data-id="element-124">
                  {s.num}
                </p>
                <p className="text-text-sec text-xs sm:text-sm leading-snug font-medium" data-id="element-125">
                  {s.label}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}